export enum PortalPropertyType {
	SFR = 'SFR',
	CONDO = 'Condo',
	MANUFACTURED = 'Manufactured',
	NON_WARRANTABLE_CONDO = 'Non-Warrantable Condo',
	TWO_TO_FOUR_UNIT = '2-4 Unit',
	TWO_UNITS = '2 Units',
	THREE_UNITS = '3 Units',
	FOUR_UNITS = '4 Units',
	PUD = 'PUD',
	COOP = 'COOP',
	MODULAR = 'Modular',
	ROWHOUSE = 'Rowhouse',
	LAND = 'Land'
}